import DistributorCNFdetails from "../Distributor/DistributorCNFdetails";
import Distributorlist from "../Distributor/Distributorlist";
import AddProductForm from "../ProductCatalogueItems/AddProductForm";
import BulkUploadData from "../ProductCatalogueItems/BulkUploadData";
import AddRetailer from "../Retailer/AddRetailer";

const BASE_URL = `${process.env.REACT_APP_BASE_URL}`;
const NEW_BASE_URL = `${process.env.REACT_APP_BASE_URL_MAIN}`;
const CSV_URL = `${process.env.REACT_APP_CSV_URL}`;
console.log(BASE_URL, CSV_URL, 'baseurllll')
console.log("BASE_URL:", BASE_URL);
console.log("Login_url:", `${BASE_URL}api/login`);

export const Config = {
    Login_url: `${BASE_URL}api/login`,
    OTPVerification_url: `${BASE_URL}api/verify-otp`,
    Notification_url: `${CSV_URL}api/notification`,
    ManufactureProfile_url: `${BASE_URL}api/manufacturers/details`,
    Block_Active_url: `${BASE_URL}api/update-status`,
    ManufacturerDetails_url: `${BASE_URL}api/manufacturers/details`,
    imageUpdate_url: `${CSV_URL}imageUpload`,
    ManufacturerUpdate_url: `${BASE_URL}api/manufacturers`,
    DataList_url: `${BASE_URL}api/manufacturers`,
    ManufactureCards_url: `${BASE_URL}api/manufacturers/stats`,
    AddManufacturer_url: `${BASE_URL}api/manufacturers/register`,
    ProfileItemsInfo_url: `${BASE_URL}api/manufacturers/details`,
    Distributorlist_url: `${BASE_URL}api/distributors`,
    DistributorCards_url: `${BASE_URL}api/distributors/stats`,
    AddDistributor_url: `${BASE_URL}api/distributors/register`,
    DistributorCNFdetails_url: `${BASE_URL}api/distributors/details`,
    DistributorUpdate_url: `${BASE_URL}api/Distributors`,
    AddRetailer_url: `${BASE_URL}api/retailers/register`,
    Retailerlist_url: `${BASE_URL}api/retailers`,
    RetailerCard_url: `${BASE_URL}api/retailers/stats`,
    RetailerProfile_url: `${BASE_URL}api/retailers/details`,
    RetailerUpdate_url: `${BASE_URL}api/retailers`,
    SendEmail_url: `${BASE_URL}api/retailers/send-credentials`,
    AddProductForm_url: `${BASE_URL}api/products/register`,
    ProductSummary_url: `${BASE_URL}api/products`,
    Add_Product_url: `${BASE_URL}api/products/register`,
    Edit_product_url: `${BASE_URL}api/products/update`,
    Get_Company_Name: `${BASE_URL}api/manufacturers`,
    Get_Manufaturers_Mapping_List: `${BASE_URL}api/productMapping/headers`,
    Get_Mapping_details: `${BASE_URL}api/productMapping/mapManufacturerNames`,
    Get_Manufaturers_List: `${BASE_URL}api/manufacturerMapSearch`,
    Add_Manufacturer: `${BASE_URL}api/manufaturerAdd`,
    BulkUploadManufacturer_url: `${CSV_URL}upload-manufacturers`,
    Manufacturer_mapp: `${BASE_URL}api/manufacturerMapp`,
    Get_Product_Mapping_List: `${BASE_URL}api/productMapping/mapProductName`,
    Get_Product_Map_Search: `${BASE_URL}api/productMapSearch`,
    Add_New_Product: `${BASE_URL}api/addMapProduct`,
    ProductCard_url: `${BASE_URL}api/products/stats`,
    Add_Map_Product: `${BASE_URL}api/productMap`,
    CSV_download: `${BASE_URL}api/stockMapping/downloadStock`,
    Map_Stock: `${BASE_URL}api/stockMapping/mapStock`,
    BulkUploadData_url: `${CSV_URL}upload-products`,
    Get_Purchased_From_List: `${BASE_URL}api/purchasedMapping/mapPurchasedFromList`,
    Get_Map_Purchased_From: `${BASE_URL}api/purchasedMapping/mapPurchasedFrom`,
    Add_New_Purchased_From: `${BASE_URL}api/purchasedMapping/addNew`,
    Fetch_Product: `${BASE_URL}api/products/product`,
    AddHSNCode_url: `${BASE_URL}api/hsn-codes`,
    Delete_HSN_url: `${BASE_URL}api/hsn-codes`,
    Search_HSN_url: `${BASE_URL}api/hsn-codes`,
    Edit_HSN_url: `${BASE_URL}api/hsn-codes`,
    Upload_HSN_url: `${CSV_URL}upload-hsn`,
    Subscription_url: `${BASE_URL}api/getplans`,
    Add_Subscription_url: `${BASE_URL}api/addPlan`,
    Edit_Subscription_url: `${BASE_URL}api/editplan`,
    Advertisement_url: `${BASE_URL}api/ads`,
    Locations_url: `${BASE_URL}api/ad-blocks`,
    ad_modules_url: `${BASE_URL}api/ad-blocks/modules`,
    Version_Control: `${BASE_URL}api/version`,
    states: `${BASE_URL}api/getStatesAndCities`,
    subscription_details: `${BASE_URL}api/distributors/subscriptionData`,
    dashboard_data: `${BASE_URL}api/overview/dashboardData`,
    update_modules: `${BASE_URL}api/distributors/updateModules`,
    plans_list: `${BASE_URL}api/getplanslist`,
    manufacturers_list: `${BASE_URL}api/manufacturers/list`,
    affiliates_list: `${BASE_URL}api/affiliate-list`,
    update_affiliate_status: `${BASE_URL}api/update-affiliate-status`,
    affiliate_stats: `${BASE_URL}api/affiliate-stats`,
    affiliate_details: `${BASE_URL}api/affiliate-details`,
    affiliate_referrals: `${BASE_URL}api/referrals-list`,
    affiliate_withdrawals: `${BASE_URL}api/withdrawals-list`,
    affiliate_update_withdrawals: `${BASE_URL}api/update-withdraw-request`,
    affiliate_commisions: `${BASE_URL}api/affiliate-comissions`,
    update_affiliate_commission: `${BASE_URL}api/update-comission-amount`,
    product_dropdowns: `${NEW_BASE_URL}get-dropdowns`,
    send_expiry_alert: `${NEW_BASE_URL}send-expiry-alerts-sms`,
    add_supplier_mfr_user: `${BASE_URL}api/add-manufacturer`,
    add_distributor_by_user: `${BASE_URL}api/add-distributor`,
    linked_supplier_by_user: `${BASE_URL}api/linked-users`,
    party_by_user: `${BASE_URL}api/party-list`,
    search_mfr: `${NEW_BASE_URL}get-list/manufacturer`,
    search_dis: `${NEW_BASE_URL}get-list/distributor`,
    stocks_by_dis: `${BASE_URL}api/get-distributor-stocks`,
    Upload_Stock_Sheet: `${CSV_URL}upload`,
    Bulk_Upload: `${CSV_URL}upload-supplier-bulk`,
    Bulk_Upload_Auth: `${BASE_URL}upload-supplier-auth`,
    Party_Bulk_Upload: `${BASE_URL}upload-party-auth`,
    org_plans_list: `${NEW_BASE_URL}org-plan-list`,
    create_org_plan: `${NEW_BASE_URL}create-org-plan-admin`,
    get_dis_stats: `${BASE_URL}api/distributors/stats-dis-panel`,
    subs_list: `${BASE_URL}subscription-prepaid-list`,
    subs_stats: `${BASE_URL}subscription-stats`,
    org_subs_list: `${BASE_URL}get-org-subscription-prepaid-list`,
    org_subs_stats: `${BASE_URL}get-org-subscription-stats`,
    download_id_name_mfr: `${BASE_URL}api/manufacturers/download-manufacturer-list`,
    product_bulk_upload: `${BASE_URL}upload-products-data`,
    manufacturer_dropdown: `${BASE_URL}api/manufacturers/get-manufacturer-dropdown`,
    trial_users: `${BASE_URL}new-user-traildays`,

    // Hospital Panel API's  

    Get_Hospitals_List: `${BASE_URL}api/hospital/get-hospital-admin`,
    Update_Hospital: `${BASE_URL}api/hospital/update-hospital`,
    Get_Hospitals_Details: `${BASE_URL}api/hospital/getHospitalProfile-admin`,
    Add_Hospital: `${BASE_URL}api/hospital/create-hospital`,

    //coupons
    get_coupons_list: `${BASE_URL}coupon-list`,
    create_coupon: `${BASE_URL}create-coupon`,
    update_coupon: `${BASE_URL}update-coupon`,
    subcription_used_coupons : `${BASE_URL}subscription-used-coupons`,
    get_subscription_coupon_details:`${BASE_URL}subscription-coupon-details`,
    subscription_coupon_stats:`${BASE_URL}subscription-coupon-stats`,

    Get_Hospitals_Profile: `${NEW_BASE_URL}getHospitalProfile`,
    Get_State_And_Cities: `${NEW_BASE_URL}getStatesAndCities`,
    Get_Card_Data: `${BASE_URL}api/hospital/get-hospital-card-data`,
}